<template>
  <div class="calendar-package">
    <div class="header" v-if="!isapplets">
      <van-icon name="arrow-left" size="20" color="#333" @click="goBack" />
      <span class="title">课程日历</span>
      <span class="exp"></span>
    </div>
    <div class="record_content">
      <el-calendar :first-day-of-week='7'>
        <template slot="dateCell" slot-scope="{date, data}" v-model="data">
          <div class="div-Calendar" @click="calendarOnClick(data)">
            <div class="every-date">
             <div>{{ data.day.split('-').slice(2).join('-') }}</div>
              <div class="red_dot" v-if="dealMyDate(data.day,'1')>0"></div>
            </div>
          </div>
        </template>
      </el-calendar>
      <ul class="live_detail">
        <div v-if='newList.length == 0' class="nodata">
          <p><img src="../../../static/images/nodata.png" alt=""></p>
          <p>当天暂无直播</p>
        </div>
        <li v-for="(item,i) in newList" :key="i" @click='go_zhibo(item)'>
            <span class="circle"></span>
          <div>
              <p class="lesson_time">{{item.start_time | localDateH}} - {{item.end_time | localDateH}}
                <span class="lesson_tag" v-if='item.start_time - 3600 < new Date().getTime()/1000 && new Date().getTime()/1000 < item.end_time - 0 + 3600'>
                  <img src="../../../static/images/living.gif" alt="">正在直播
                </span>
                <span class="lesson_tag" v-if='(item.end_time - 0 + 3600 < new Date().getTime()/1000) && item.offline_code'>看回放</span>
                <span v-if='(item.end_time - 0 + 3600 < new Date().getTime()/1000) && item.offline_code == ""'>已结束</span>
                <span v-if='item.start_time - 3600 > new Date().getTime()/1000'>未开始</span>
                </p>
              <p class="lesson_name">{{item.lesson_name}}</p>
              <p class="lesson_packname">{{item.package_name}}</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="class_dialog" v-if='zujian_flag'>
      <div class="dialog_box">
        <div class="dialog_message">手机浏览器暂不支持查看该课件<br/>你可在"{{ appname }}"进行查看</div>
        <p><span @click='cancel_flag'>取消</span>
          <!-- <wx-open-launch-app v-if='ua.match(/MicroMessenger/i) == "micromessenger"&&android'
            id="launch-btn" @error="handleErrorFn" @launch="handleLaunchFn" :appid=appid
            :extinfo="JSON.stringify({'type': 1, 'orderSn': sn, 'owner': this.$route.query.owner, 'channel': this.$route.query.channel, 'orgn': this.$route.query.orgn})"
          >
            <script type="text/wxtag-template">
              <style>.btn { color: #fff; font-size: 10px; text-align:center; line-height:23px}
			         </style>
               <div class="btn">去APP查看</div>
            </script>
          </wx-open-launch-app> -->
          <span v-if='android' class="goapp"><a :href="scheme + '?type=1&orderSn='+ sn + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn" @click='search_flag'>打开APP</a></span>
          <span v-else-if='ios' class="goapp" @click='search_flag'>去APP查看</span>
        </p>
      </div>
    </div>
    <popup :type='1' @isopen="popup" class="popop_content" v-if='applets_flag&&ios'></popup>
    <popup :type='2' @isopen="popup" class="popop_content" v-if='applets_flag&&android'></popup>
    <arouse v-if="arshow" @arouse='receive'></arouse>
  </div>
</template>
<script>
import popup from "../popup/index" //小程序弹窗
import localDateH from "../../utils/localDate.js";
import arouse from '../arouse/index.vue'
import { Toast } from "vant";

export default {
  data() {
    return {
      ticket: JSON.parse(localStorage.getItem("ticketObj"))["offcn-ticket"],
      ticket_source: JSON.parse(localStorage.getItem("ticketObj")).ticket_source,
      calendarlist: [],
      newList: [],
      len: 0,
      zujian_flag: false,
      ua: navigator.userAgent.toLowerCase(),
      android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
      ios: navigator.userAgent.match(/iPad/) || navigator.userAgent.match(/iPhone/) || navigator.userAgent.match(/iPod/),
      sn: '',
      shopid: '',
      applets_flag: false,
      isapplets: false,
      detail: '',
      arshow: false,
      sf: '',
      isweixin: false,
      appid: '',
      scheme: ''
    }
  },
  filters: {
    localDateH: function (value) {
      return localDateH(value);
    },
  },
  components: {
    popup,
    arouse
  },
  methods: {
    receive (val) {
      this.arshow = val
    },
    handleErrorFn(e) {
      this.arshow = true
      console.log(JSON.stringify(e), '跳转失败')
      Toast("当前手机未下载中公教育app");
      // this.download() // 这里跳转App下载页面
    },
    // 监听launch 函数
    handleLaunchFn(e) {
      // 跳转成功
      console.log(JSON.stringify(e), '跳转成功')
    },
    download(){
      //判断iPhone|iPad|iPod|iOS
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          window.location.href ="https://apps.apple.com/cn/app/%E4%B8%AD%E5%85%AC%E6%95%99%E8%82%B2/id735754930";
      } else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
          window.location.href ="https://a.app.qq.com/o/simple.jsp?pkgname=com.offcn.android.offcn&channel=0002160650432d595942&fromcase=60001";
      } else {  // PC端
          window.location.href ="https://www.offcn.com/daohang/zgapp/#nub1";
      }
    },
    handleJudgeWechat() {
      const wechatInfo = window.navigator.userAgent.match(
        /MicroMessenger\/([\d\.]+)/i
      );
      if (!wechatInfo) return;
      let judgewechat = wechatInfo[1].split(".");
      let flag = false;
      if (judgewechat[0] >= 7) {
        if (judgewechat[1] >= 0) {
          if (judgewechat[2] >= 12) {
            this.wechatState = true;
            flag = true;
          }
        }
      }
      if (!flag) {
        Toast.fail('请升级当前微信版本');
        return false
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    getCalendar(page) {
      this.$api.GETCALENDAR({
        "offcn-ticket": this.ticket,
        ticket_source: this.ticket_source,
      }).then((res) => {
        if (res.code == 0) {
          this.calendarlist = res.data.calendar;
        } else if (res.code == 2) {
          this.$router.push({ path: "/" });
        }
      })
    },
    loadmore() {
      this.page++
      this.getCalendar(this.page);
    },
    calendarOnClick(data) {
      this.newList = []
      this.dealMyDate(data.day);
    },
    dealMyDate(v, key) {
      let len = this.calendarlist.length
      let res = ""
      if (key) {
        for (let i = 0; i < len; i++) {
          if (this.timeFormat(this.calendarlist[i].timestamp * 1000) == v) {
            res = this.calendarlist[i].list.length;
          }
        }
        return res;
      } else {
        for (let i = 0; i < len; i++) {
          if (this.timeFormat(this.calendarlist[i].timestamp * 1000) == v) {
            this.newList = this.calendarlist[i].list;
          }
        }
      }
    },
    //时间戳处理，不足10补0
    addZero(m) {
      return m < 10 ? "0" + m : m;
    },
    timeFormat(timestamp) {
      var time = "";
      time = new Date(timestamp);
      var year = time.getFullYear();
      var month = time.getMonth() + 1;
      var date = time.getDate();
      var hours = time.getHours();
      var minutes = time.getMinutes();
      var seconds = time.getSeconds();
      return (
        year + "-" + this.addZero(month) + "-" + this.addZero(date)
      );
    },
    go_zhibo(item) {
      this.$api.GETCATALOG({
        system_order_num: item.system_order,
        package_id: item.course_id,
        coding: item.cid,
        menu_id: item.lesson_id
      }).then((res) => {
        if (res.code == 0) {
          let info = res.data.catalog.info
          if (item.lesson_type == 3) {
            if (item.learning_style && item.learning_style.indexOf(2) == -1) {
              this.detail = item
              this.detail.order_id = this.$route.query.order_id
              this.detail.package_id = item.course_id
              this.detail.cid = item.cid
              this.detail.shopid = this.shopid
              if (this.isapplets) {
                this.applets_flag = true
              } else {
                this.sn = item.system_order
                this.zujian_flag = true
              }
            } else {
              if (item.offline_code) {
                location.href = item.url_online
              } else {
                location.href = item.url_liveshow
              }
            }
            // this.$router.push({
            //   path: "/livevod",
            //   query: {
            //     order_id: item.system_order,
            //     package_id: item.package_id,
            //     cid: item.cid,
            //     unit_id: item.lesson_id,
            //     live_type: 1,
            //     module_type: 6,
            //     url: item.url_liveshow
            //   }
            // })
          } else if (item.lesson_type == 9) {
            if (item.learning_style && item.learning_style.indexOf(2) == -1) {
              this.detail = item
              this.detail.order_id = this.$route.query.order_id
              this.detail.package_id = item.course_id
              this.detail.cid = item.cid
              this.detail.shopid = this.shopid
              if (this.isapplets) {
                this.applets_flag = true
              } else {
                this.sn = item.system_order
                this.zujian_flag = true
              }
            } else {
              if (item.start_time-3600 < new Date().getTime()/1000 && new Date().getTime()/1000 < item.end_time - 0 + 3600) {
                this.$router.push({
                  path: "/livevod",
                  query: {
                    order_id: item.system_order,
                    package_id: item.course_id,
                    cid: item.cid,
                    unit_id: item.lesson_id,
                    module_type: 6,
                    url: info.live_record_url
                  }
                })
              } else if (item.start_time - 3600 > new Date().getTime()/1000) {
                Toast("直播未开始");
              } else if ((item.end_time - 0 + 3600 < new Date().getTime()/1000) && item.offline_code) {
                this.$router.push({
                  path: "/livevod",
                  query: {
                    order_id: item.system_order,
                    package_id: item.course_id,
                    cid: item.cid,
                    unit_id: item.lesson_id,
                    live_type: 3,
                    module_type: 66,
                    url: info.live_record_url
                  }
                })
              } else {
                Toast("暂无回放");
              }
            }
          } else {
            if (this.isapplets) {
              this.applets_flag = true
            } else {
              this.zujian_flag = true
              this.$nextTick(() => {
                var btn = document.getElementById('launch-btn')
                btn.addEventListener('launch', function(e) {
                  this.handleJudgeWechat(); //是否满足跳转app条件
                });
              })
            }
          }
        } else if (res.code == 2) {
          this.$router.push({ path: "/" });
        }
      })
    },
    cancel_flag() {
      this.zujian_flag = false
    },
    popup () {
      this.applets_flag = false
    },
    search_flag() {
      if(!this.isweixin){
        this.arshow = false;
        if (this.sf == 'zgyouzhi'){
          if (this.android) {
            var SERVER_BASE_URL
            if (process.env.NODE_ENV=='production') {
              SERVER_BASE_URL = 'https://zgjyapp.offcn.com/web/app/youzhi_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
            } else {
              SERVER_BASE_URL = 'http://tiku.eoffcn.com/web/app/youzhi_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
            }
            this.openApp(SERVER_BASE_URL);
          } else if (this.ios) {
            location.href = 'https://www.eoffcn.com/zg_youzhi/detail?type=1&orderSn=' + this.sn + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
          }
        } else {
          if (this.android) {
            var SERVER_BASE_URL
            if (process.env.NODE_ENV=='production') {
              SERVER_BASE_URL = 'https://zgjyapp.offcn.com/web/app/offcn_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
            } else {
              SERVER_BASE_URL = 'http://tiku.t.eoffcn.com/web/app/offcn_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
            }
            this.openApp(SERVER_BASE_URL);
          } else if (this.ios) {
            location.href = 'https://www.eoffcn.com/zg_jiaoyu/detail?type=1&orderSn=' + this.sn + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
          }
        }
      }else{
        this.arshow = true;
      }
    },
    openApp (src) {
      var d = new Date()
      var t0 = d.getTime()
      var delay = setInterval(function() {
        var d = new Date();
        var t1 = d.getTime();
        if( t1-t0<3000 && t1-t0>2000) {
          window.location.href = src;
        }
        if (t1 - t0 >= 3000) {
          clearInterval(delay);
        }
      },2000);
    }
  },
  mounted() {
    // 小程序内
    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        this.isapplets = true
      }
    })
    this.getCalendar();
    let todayBtn = document.querySelector(
      ".el-calendar__button-group .el-button-group>button:nth-child(2)"
    );
    todayBtn.addEventListener("click", () => {
      this.calendarOnClick({ isSelected: true, type: "current-month", day: this.timeFormat(new Date().getTime()) });
    });
    //是否是微信浏览器
    if (/(micromessenger)/i.test(navigator.userAgent)) {
      //是否电脑微信或者微信开发者工具
      if(/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)){
        console.log('电脑微信或者微信开发者工具')
        this.isweixin = false;
      }else{
        //手机微信打开的浏览器
        console.log('手机微信')
        this.isweixin = true;
      }
    } else {
      console.log('其他浏览器')
      this.isweixin = false;
    }
    this.sf = this.$route.query.sf
    if (this.sf == 'zgyouzhi') {
      this.appid = 'wx91652b0b55a2ca52'
      this.appname = '优职'
      this.scheme = 'zgyouzhi://openapp'
    } else {
      this.appid = 'wx4a8209bce2ce2a1d'
      this.appname = '中公教育'
      this.scheme = 'zhonggongjiaoyu://openapp'
    }
  },
  watch: {
    "calendarlist": function (val) {
      this.calendarOnClick({ isSelected: true, type: "current-month", day: this.timeFormat(new Date().getTime()) });
      this.calendarlist = val;
    }
  },
};
</script>
<style lang="less" scoped>
// /deep/ .el-calendar__header {

//   .el-calendar__title {
//     font-size: 50px;
//     font-weight: bold;
//   }
// }
/deep/ .el-timeline-item:first-child .el-timeline-item__node--normal {
  background: red;
}
/deep/ .el-calendar-table {
  display: block;
  text-align: center;
  tbody{
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  thead,tbody tr{
    width: 100%;
    display: flex;
    justify-content: space-around;
  }
  .el-calendar-day {
    height: 70px;
  }
  tr:first-child td {
    border: none;
  }
  tr td:first-child {
    border: none;
  }
  td {
    border: none;
    vertical-align: initial;
    height: 70px;
    &.is-selected{
      background: none;
      .el-calendar-day {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background-color: #e8e8e8;
      }
    }
  }
  .el-calendar-day{
    height: 60px;
    width: 60px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
/deep/ .el-calendar__body {
  margin-bottom: 140px;
  padding: 12px 20px 20px;
  border-bottom: 1px solid #e9ebec;
  .div-Calendar{
    width: 60px;
    height: 60px;
    border-radius: 50%;
    // display: flex;
    // flex-direction: column;
    // justify-content: center
  }
  .is-today {
    color: #e60012;
    .el-calendar-day{
      background: #e60012!important;
      border-radius: 50%;
      color: #fff;
    }
    .red_dot{
      background: #fff!important;
    }
  }
}
#launch-btn {
  position: absolute;
  right: 0;
  width: 242px;
  height: 68px;
}
.calendar-package {
  width: 100%;
  min-height: 100%;
  background: #ffffff;
  .header {
    position: fixed;
    z-index: 2;
    top: 0;
    width: 100%;
    height: 90px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px 0 25px;
    color: #333;
    border-bottom: 1px solid #e5e5e5;
    .title {
      font-size: 32px;
      font-weight: bold;
    }
    .exp {
      width: 62px;
    }
  }
  .record_content {
    padding-top: 100px;
    .record_detail {
      padding-bottom: 40px;
      .record_date {
        font-size: 24px;
        font-weight: bold;
      }
    }
  }
  .every-date {
    position: relative;
    font-size: 0.373333rem;
    width: 100%;
    height: 100%;
    // display: flex;
    // align-items: center;
    // flex-direction: column;
    // justify-content: center;
    >div:first-child{
      line-height: .8rem;
      text-align: center;
    }
    .red_dot {
      position: absolute;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: red;
      left: 50%;
      bottom: 8px;
      transform: translate(-50%);
    }
  }
  .live_detail {
    margin: 0 40px;
    color: #999999;
    li {
      font-size: 28px;
      padding-bottom: 70px;
      padding-left: 30px;
      border-left: 1px solid #cbcbcb;
      position: relative;
      display: flex;
      .circle{
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: red;
        position: absolute;
        left: -10px;
        top: -5px ;
        z-index: 1;
      }
      >div{
        width: 100%;
        margin-top: -10px;
      }
      .lesson_time {
        span{
          float: right;
          font-size: 24px;
        }
        .lesson_tag {
          color: #e60012;
          font-weight: bold;
          img {
            width: 24px;
            margin-right: 10px;
          }
        }
      }
      .lesson_name {
        color: #333333;
        font-size: 34px;
        font-weight: bold;
        margin-top: 20px;

      }
      .lesson_packname {
        margin-top: 20px;
      }
    }
    li:last-child {
      border: none;
    }
  }
}
.nodata{
  text-align: center;
  color: #666;
  font-size: 30px;
  img{
    display: inline-block;
    width: 250px;
    height: 187px;
    margin-bottom: 40px;
  }
}
.class_dialog {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
  z-index: 2;
  .dialog_box {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 490px;
    line-height: 40px;
    border-radius: 18px;
    transform: translate(-50%, -50%);
    background: #fff;
    .dialog_message {
      text-align: center;
      padding: 30px 30px;
    }
    p {
      display: flex;
      border-top: 1px solid #e5e5e5;
      height: 70px;
      line-height: 70px;
      span {
        flex: 1;
        text-align: center;
      }
      .goapp {
        color: #e60012;
        border-left: 1px solid #e5e5e5;
      }
    }
  }
}
.popop_content {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/calendar/calendar.vue